import elm from '../elm';
import pubsub from '../pubsub';
import notes from '../notes';
import playSound from '../sound';
import eighthNoteSvg from './eighth-note-svg';
import letterSounds from '../letter-sounds';

const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('');

let elScene;
let elLetters;
let elExclamationMark;
let elQuestionMark;
let elSong;

function abc() {
  elScene = elm.findOne('.scene-abc');

  render();

  elLetters = elm.find('.letter');
  elExclamationMark = elm.findOne('.exclamation-mark');
  elQuestionMark = elm.findOne('.question-mark');
  elSong = elm.findOne('.song-abc');

  elm.tap(elLetters, onTapLetter);
  elm.tap(elExclamationMark, exclamationMark);
  elm.tap(elQuestionMark, questionMark);

  elm.tap(elSong, () => {
    const randomWaveType = ['square', 'triangle', 'sine', 'sawtooth'][Math.floor(Math.random() * 4)];

    notes.playNotes(notes.abcNotes(), randomWaveType, 0, 200, afterNote);

    onOff(elSong);
  });

  elm.tap(elm.findOne('.to-123'), () => {
    pubsub.publish('ActivateScene', ['scene-123']);
  });

  pubsub.subscribe('KeyPress', activateLetter);
  pubsub.subscribe('ActivateScene', maybeActivateScene);
}

function afterNote(note, remainingNotes) {
  if (note === 'rest') return;

  let noteCount = 17 - remainingNotes;

  if (noteCount > 7) noteCount -= 1;

  const elCurrentLetter = elLetters[noteCount];

  onOff(elCurrentLetter);

  if (remainingNotes === 0) {
    onSongEnd();
  }
}

function onSongEnd() {
  elm.each(elLetters, elLetter => elLetter.classList.remove('active'));

  elExclamationMark.classList.add('active');

  setTimeout(() => {
    elExclamationMark.classList.remove('active');
  }, 700);
}

function maybeActivateScene(sceneName) {
  if (sceneName === 'scene-abc') {
    elScene.classList.add('active');
  } else {
    elScene.classList.remove('active');
  }
}

function activateLetter(elLetter, letter) {
  elLetter = elLetter || elm.findOne(`[data-letter="${letter}"]`);

  if (elLetter) {
    letter = letter || elLetter.getAttribute('data-letter');

    onOff(elLetter, () => {
      letterSounds.play(letter);
    });
  }
}

function exclamationMark(event) {
  const el = event.currentTarget;

  onOff(el, () => {
    playSound('exclamationMark');
  });
}

function questionMark(event) {
  const el = event.currentTarget;

  onOff(el, () => {
    playSound('questionMark');
  });
}

function onTapLetter(event) {
  activateLetter(event.currentTarget);
}

function onOff(elTarget, callback) {
  if (elTarget.classList.toggle('active')) {
    if (callback) callback();

    setTimeout(() => {
      elTarget.classList.toggle('active', false);
    }, 400);
  }
}

function render() {
  const lettersHTML = [];

  alphabet.forEach((letter) => {
    lettersHTML.push(`<div class="grid-item letter" data-letter="${letter}"><div>${letter}</div></div>`);
  });

  lettersHTML.push(`<div class="grid-item song-abc"><div>${eighthNoteSvg}</div></div>`);
  lettersHTML.push('<div class="grid-item exclamation-mark"><div>!</div></div>');
  lettersHTML.push('<div class="grid-item question-mark"><div>?</div></div>');
  lettersHTML.push('<div class="grid-item to-123"><div>123<br>&circlearrowleft;</div></div>');

  elScene.innerHTML = lettersHTML.join('');
}

export default abc;



// WEBPACK FOOTER //
// ./src/js/scenes/abc.js